export default "__VITE_ASSET__D0JRdKHD__"